import InteroperableObj from "../InteroperableObj";

const {menu,ccclass, property} = cc._decorator;

@ccclass
@menu("游戏物体/石狮子")
export default class StoneLion extends InteroperableObj {
    // 点击石狮子 石狮子会倒下 当石狮子倒下的时候村长会过来找你的麻烦  需要增加村长找麻烦的事件
    onLoad(){
        super.onLoad();
        this.node.on("touchend",this.onTouchEnd,this);
    }
    
    onTouchEnd(e:cc.Event.EventTouch){

    }

    initObj(){
        
    }
}
